// @flow
import type {Action} from '../../../state/types'

export type OnPlaceSearchPayload = {
  text: string,
}

const id = 'map/ON_PLACE_SEARCH'

export const onPlaceSearch = (text: string): Action<OnPlaceSearchPayload> => ({
  type: id,
  payload: {
    text,
  }
})

onPlaceSearch.id = id
